'use client'

import { useEffect, useState } from 'react'

import { useRouter } from 'next/navigation'

import Typography from '@mui/material/Typography'

import classnames from 'classnames'
import { getSession, signIn, useSession } from 'next-auth/react'

import axios from 'axios'

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import dayjs from 'dayjs'
import { OTPInput } from 'input-otp'

import type { SlotProps } from 'input-otp'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Divider from '@mui/material/Divider'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import DialogActions from '@mui/material/DialogActions'
import Grid from '@mui/material/Grid'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

import showToastAlert from '@components/Toast'
import { encryptAES } from '@/utils/getUrlApiLogin'
import NumericFormatCustom from '@/components/NumericFormatCustom'
import CustomButton from '@/components/layout/shared/CustomButton'
import { useSettings } from '@core/hooks/useSettings'
import LogoLogin from '@/components/layout/shared/LogoLogin'
import styles from './inputOtp.module.css'
import themeConfig from '@configs/themeConfig'

const dataShift = [
  { value: 0, label: 'Pagi' },
  { value: 1, label: 'Siang' },
  { value: 2, label: 'Malam' }
]

interface DataUnit {
  ID_UNIT: string
  NAMA_UNIT: string
  ALAMAT: string
  KOTA: string
  LABA: string
  NONRACIK: string
  RACIK: string
  DT: string
  BPJS_LABA: string
  BPJS_NONRACIK: string
  BPJS_RACIK: string
  BPJS_DT: string
  ID_AKUN: string
  ID_KAS: string
  ID_JUAL: string
}

type Pelanggan = {
  ID_USAHA: string
  NAMA_USAHA: string
  ALAMAT_USAHA: string
  KOTA_USAHA: string
  NPWP: string
  URLPUSAT: string
  URLUTAMA: string
  URLPUSAT_DOMAIN: string
  URLUTAMA_DOMAIN: string
  GAMBAR_LOGO: string
  GAMBAR_BACKGROUND: string
}

const Slot = (props: SlotProps & { disabled?: boolean }) => {
  return (
    <div
      className={classnames(
        styles.slot,
        { [styles.slotActive]: props.isActive },
        { [styles.slotDisabled]: props.disabled }
      )}
    >
      {props.char !== null && <div>{props.char}</div>}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  )
}

const FakeCaret = () => {
  return (
    <div className={styles.fakeCaret}>
      <div className='w-px h-5 bg-textPrimary' />
    </div>
  )
}

const Login = () => {
  const { settings } = useSettings()

  const router = useRouter()
  const { data: session, status } = useSession()

  const [isPasswordShown, setIsPasswordShown] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingSimpan, setLoadingSimpan] = useState<boolean>(false)

  const [idUsaha, setIdUsaha] = useState('')
  const [open, setOpen] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const [dataPelanggan, setDataPelanggan] = useState<Pelanggan | null>(null)
  const [openDialog, setOpenDialog] = useState(false)

  const [unitList, setUnitList] = useState<DataUnit[]>([]) // Tambahkan state untuk unit list

  const handleClickShowPassword = () => setIsPasswordShown(show => !show)

  const [tglTransOrder, setTglTransOrder] = useState<dayjs.Dayjs | null>(dayjs())
  const [selectedShift, setselectedShift] = useState('')
  const [saldo, setSaldo] = useState('')
  const [pegawai, setPegawai] = useState('')
  const [idUnit, setIdUnit] = useState('')
  const [idPegawai, setIdPegawai] = useState('')
  const [selectedUnit, setUnitSelected] = useState('')
  const [rowSelectedUnit, setRowSelectedUnit] = useState<DataUnit | null>(null)
  const [namaUsaha, setNamaUsaha] = useState('')
  const [latitude, setLatitude] = useState<number | null>(null)
  const [longitude, setLongitude] = useState<number | null>(null)
  const [fingerprintId, setFingerprintId] = useState<string>('')
  const [openFingerprintDialog, setOpenFingerprintDialog] = useState(false)
  const [locationError, setLocationError] = useState<string | null>(null)

  useEffect(() => {
    // Initialize an agent
    const fpPromise = FingerprintJS.load()

    fpPromise
      .then(fp => fp.get())
      .then(result => {
        setFingerprintId(result.visitorId)
      })

    getLocation()
  }, [])

  const getLocation = () => {
    if (!navigator.geolocation) {
      setLocationError('Geolocation tidak didukung browser ini.')

      return
    }

    // Opsi konfigurasi untuk akurasi tinggi
    const options = {
      enableHighAccuracy: true, // Memaksa browser menggunakan GPS (jika tersedia)
      timeout: 10000, // Waktu tunggu maksimal (10 detik) sebelum error
      maximumAge: 0 // Jangan gunakan lokasi yang dicache, cari yang baru
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        setLatitude(position.coords.latitude)
        setLongitude(position.coords.longitude)
        setLocationError(null)
      },
      error => {
        setLocationError('Gagal mendapatkan lokasi: ' + error.message)
      },
      options // <--- Masukkan opsi di sini sebagai parameter ketiga
    )
  }

  const handleChangeUnit = (value: any) => {
    if (value) {
      setUnitSelected(value.ID_UNIT)
      setRowSelectedUnit(value)
    } else {
      setUnitSelected('')
      setRowSelectedUnit(null)
    }
  }

  useEffect(() => {
    if (status === 'authenticated') {
      const redirectTo = '/kasir-home'

      router.push(redirectTo)
    }
  }, [status, session, router])

  const clearAllCookies = async () => {
    // Hapus client-side cookies
    const cookies = document.cookie.split('; ')

    cookies.forEach(cookie => {
      const [name] = cookie.split('=')

      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`
    })

    console.log('Client-side cookies cleared!')

    // Hapus server-side cookies
    try {
      await axios.get('/api/clear-cookies')
      console.log('Server-side cookies cleared!')
    } catch (error) {
      console.error('Failed to clear server-side cookies:', error)
    }
  }

  const doLoginLangganan = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!idUsaha) {
      showToastAlert('info', 'ID Usaha tidak boleh kosong')

      return
    }

    setLoading(true)
    await clearAllCookies()

    try {
      const formData = {
        idusaha: idUsaha
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(
        (process.env.NEXT_PUBLIC_API_URL_LOGIN_FRANCHISE as string) + 'login/loginfranchise',
        {
          data: encryptedData
        }
      )

      if (response.data.metadata.code === 200) {
        setDataPelanggan(response.data.response.list[0] || {})
        setNamaUsaha(response.data.response.list[0].NAMA_USAHA || '')

        // Ambil list unit
        const unitResponse = await axios.post(response.data.response.list[0].URLUTAMA_DOMAIN + 'ref/unitusaha', {
          data: encryptedData
        })

        if (unitResponse.data.metadata.code === 200) {
          const units = unitResponse.data.response.list || []

          setUnitList(units)

          if (units.length > 0) {
            setUnitSelected(units[0].ID_UNIT)
            setRowSelectedUnit(units[0])
          }
        } else {
          setUnitList([])
          setUnitSelected('')
          setRowSelectedUnit(null)
        }

        setOpen(true)
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error: any) {
      console.error('Error login:', error)
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const doLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!username) {
      showToastAlert('info', 'Username tidak boleh kosong')

      return
    }

    if (!password) {
      showToastAlert('info', 'Password tidak boleh kosong')

      return
    }

    setLoading(true)

    try {
      const formData = {
        user: username,
        pass: password,
        idusaha: dataPelanggan?.ID_USAHA
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(dataPelanggan?.URLUTAMA_DOMAIN + 'login/loginadmin', {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        const session = response.data.response.list[0]

        if (session) {
          const idJabatan = session?.ID_JABATAN
          const idPegawai = session?.ID_PEGAWAI
          const idUnit = session?.ID_UNIT

          if (idJabatan === '3' || idJabatan === 3) {
            setPegawai(session?.NAMA_PEGAWAI)
            setIdPegawai(session?.ID_PEGAWAI)
            setIdUnit(session?.ID_UNIT)

            cariRegKasir(idPegawai, idUnit)
          } else {
            showToastAlert('info', 'Anda tidak memiliki hak akses')
          }
        } else {
          showToastAlert('info', 'Anda tidak memiliki hak akses')
        }
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const cariRegKasir = async (idPegawai: string, idUnit: string) => {
    try {
      const formData = {
        idpegawai: idPegawai,
        idunit: idUnit,
        idusaha: dataPelanggan?.ID_USAHA
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(dataPelanggan?.URLUTAMA_DOMAIN + 'kasir/cariregkasir', {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        const data = response.data.response.list[0]

        doLoginSession(data?.NOMOR)
      } else {
        setOpenDialog(true)
        setSaldo('0')
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    }
  }

  const doLoginSession = async (noreg: string = '') => {
    if (username === '' || password === '') {
      showToastAlert('info', 'Username dan Password tidak boleh kosong')

      return
    }

    setLoading(true)

    const formData = {
      user: username,
      pass: password,
      idusaha: idUsaha,
      idunit: selectedUnit,
      deviceid: fingerprintId
    }

    const encryptedData = await encryptAES(JSON.stringify(formData))

    try {
      const result = await signIn('credentials', {
        redirect: false,
        data: encryptedData,
        url: dataPelanggan?.URLUTAMA,
        noreg: noreg,
        dataUnit: JSON.stringify(rowSelectedUnit),
        dataPelanggan: JSON.stringify(dataPelanggan),
        isurlpublic: 'true'
      })

      if (result?.error) {
        showToastAlert('info', result.error)
      } else {
        try {
          const session = await getSession()
          const idPegawai = await session?.user?.idPegawai

          const logData = {
            idunit: rowSelectedUnit?.ID_UNIT,
            idusaha: dataPelanggan?.ID_USAHA,
            idpegawai: idPegawai,
            status: 0, // login
            namauser: username,
            longitude: longitude || '',
            latitude: latitude || ''
          }

          const encryptedLogData = await encryptAES(JSON.stringify(logData))

          const logResponse = await axios.post((dataPelanggan?.URLUTAMA_DOMAIN as string) + 'login/savelogin_logout', {
            data: encryptedLogData
          })

          if (logResponse.data?.metadata?.code !== 200) {
            showToastAlert('error', logResponse.data?.metadata?.message || 'Gagal menyimpan log login')
            setLoading(false)

            return
          } else {
            router.push(themeConfig.homePageUrl)
          }
        } catch (err) {
          showToastAlert('error', 'Gagal menyimpan log login')
          setLoading(false)

          return
        }
      }
    } catch (error) {
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    localStorage.removeItem('sessionExpiry')
    setOpenDialog(false)
  }

  const handleShiftChange = (event: any, value: any) => {
    if (value) {
      setselectedShift(value.value)
    } else {
      setselectedShift('')
    }
  }

  const saveRegistrasi = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setLoadingSimpan(true)

    try {
      const url = `${dataPelanggan?.URLUTAMA_DOMAIN}kasir/saveregkasir`

      const formData = {
        nomor: null,
        idunit: idUnit,
        idusaha: dataPelanggan?.ID_USAHA,
        tgl: tglTransOrder ? tglTransOrder.format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm'),
        idpegawai: idPegawai,
        shift: selectedShift || 0,
        saldo: saldo || '0',
        idaktif: '0'
      }

      const encryptedData = await encryptAES(JSON.stringify(formData))

      const response = await axios.post(url, {
        data: encryptedData
      })

      if (response.data.metadata.code === 200) {
        setOpen(false)
        const data = response.data.response.list[0]

        doLoginSession(data?.NOMOR)
      } else {
        showToastAlert('info', response.data.metadata.message)
      }
    } catch (error) {
      console.error('Error:', error)
      showToastAlert('error', error instanceof Error ? error.message : 'Unknown error')
    } finally {
      setLoadingSimpan(false)
    }
  }

  const handleCloseUnit = () => {
    setOpen(false)
    setDataPelanggan(null)
    setUnitList([])
  }

  return (
    <>
      <Dialog fullWidth open={openDialog} onClose={handleClose} maxWidth='xs' scroll='body' transitionDuration={0}>
        <form noValidate autoComplete='off' onSubmit={saveRegistrasi} className='flex flex-col gap-5'>
          <DialogContent className='overflow-visible pbs-0 sm:pbe-2 sm:pli-5'>
            <div className='flex justify-between items-center mb-5 mt-5'>
              <Typography variant='h5'>Registrasi Kasir</Typography>
              <IconButton onClick={handleClose} color='primary' size='small'>
                <i className='ri-close-line' />
              </IconButton>
            </div>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} mt={-1}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DateTimePicker']}>
                    <DemoItem>
                      <DateTimePicker
                        readOnly
                        label='Tanggal'
                        sx={{ width: '100%' }}
                        format='YYYY-MM-DD HH:mm'
                        ampm={false}
                        value={tglTransOrder}
                        onChange={newValue => {
                          setTglTransOrder(newValue)
                        }}
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled
                  InputProps={{
                    readOnly: true
                  }}
                  sx={{
                    '& .MuiInputBase-input': {
                      textAlign: 'left',
                      color: 'black',
                      opacity: 1
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                      '& .MuiInputBase-input': {
                        color: 'black'
                      }
                    }
                  }}
                  fullWidth
                  label='Pegawai'
                  onChange={e => setPegawai(e.target.value)}
                  defaultValue={pegawai}
                  placeholder='Pegawai'
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  disableClearable
                  options={dataShift}
                  getOptionLabel={option => option.label}
                  value={
                    dataShift.find(option => option.value === Number(selectedShift)) ?? {
                      label: '',
                      value: 0
                    }
                  }
                  onChange={handleShiftChange}
                  renderInput={params => <TextField {...params} label='Pilih Shift' />}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label='Saldo'
                  onChange={e => setSaldo(e.target.value)}
                  defaultValue={saldo}
                  placeholder='Saldo'
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                    inputProps: {
                      style: { textTransform: 'uppercase', textAlign: 'right', opacity: 1 }
                    }
                  }}
                  sx={{
                    '& .MuiInput-input': {
                      textAlign: 'right'
                    }
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className='justify-center pbs-0 sm:pbe-6 sm:pli-5'>
            <CustomButton type='submit' loading={loadingSimpan}>
              Simpan
            </CustomButton>
            <CustomButton
              variant='outlined'
              type='reset'
              onClick={handleClose}
              color='secondary'
              loading={loadingSimpan}
            >
              Keluar
            </CustomButton>
          </DialogActions>
        </form>
      </Dialog>
      <div className='flex bs-full justify-center' style={{ display: openDialog ? 'none' : undefined }}>
        <div
          className={classnames(
            'flex bs-full items-center justify-center flex-1 min-bs-[100dvh] relative p-6 max-md:hidden',
            {
              'border-ie': settings.skin === 'bordered'
            }
          )}
        >
          <img
            src='/images/icon/logo_blue_big.jpg'
            alt=''
            className='absolute inset-0 w-full h-full object-cover z-[-1]'
          />
        </div>
        <div className='flex justify-center items-center bs-full bg-backgroundPaper !min-is-full p-6 md:!min-is-[unset] md:p-12 md:is-[480px]'>
          <div className='absolute block sm:hidden block-start-5 inline-start-6'>
            <LogoLogin />
          </div>
          <div className='flex flex-col gap-5 is-full sm:is-auto md:is-full sm:max-is-[400px] md:max-is-[unset]'>
            <div>
              <Typography variant='h5' className='text-center'>
                Selamat datang di
                <strong>{` ${themeConfig.templateName}! 👋🏻`}</strong>
              </Typography>
            </div>
            <form
              noValidate
              onSubmit={open ? doLogin : doLoginLangganan}
              autoComplete='off'
              className='flex flex-col gap-5'
            >
              <div className='flex flex-col gap-2'>
                <Typography>Kode Franchise</Typography>
                <OTPInput
                  onChange={value => {
                    if (open) return
                    setIdUsaha(value)
                    setOpen(false)
                  }}
                  value={idUsaha ?? ''}
                  maxLength={4}
                  disabled={open}
                  containerClassName='flex items-center'
                  render={({ slots }) => (
                    <div className='flex items-center justify-between w-full gap-4'>
                      {slots.slice(0, 4).map((slot, idx) => (
                        <Slot key={idx} {...slot} disabled={open} />
                      ))}
                    </div>
                  )}
                />
              </div>
              {open && (
                <>
                  <TextField
                    autoFocus
                    fullWidth
                    label='Nama Usaha'
                    value={namaUsaha}
                    InputProps={{
                      readOnly: open,
                      style: { textAlign: 'left', backgroundColor: open ? '#f0f0f0' : '' },
                      inputProps: {
                        style: { textAlign: 'left', textTransform: 'uppercase' }
                      }
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: open ? '#f0f0f0' : ''
                      },
                      '& .MuiInput-input': {
                        textAlign: 'left'
                      }
                    }}
                  />
                  <Autocomplete
                    autoFocus
                    options={unitList}
                    getOptionLabel={(option: string | DataUnit) => {
                      if (typeof option === 'string') {
                        return option
                      } else {
                        return option.NAMA_UNIT
                      }
                    }}
                    value={
                      unitList.find((option: DataUnit) => Number(option.ID_UNIT) === Number(selectedUnit)) || undefined
                    }
                    onChange={(event, value) => {
                      handleChangeUnit(value as DataUnit)
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='Unit Usaha'
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true // Membuat input tidak bisa diketik manual
                        }}
                      />
                    )}
                    disableClearable
                  />
                  <TextField fullWidth label='Username' onChange={e => setUsername(e.target.value)} />
                  <TextField
                    fullWidth
                    label='Password'
                    type={isPasswordShown ? 'text' : 'password'}
                    onChange={e => setPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            size='small'
                            edge='end'
                            onClick={handleClickShowPassword}
                            onMouseDown={e => e.preventDefault()}
                          >
                            <i className={isPasswordShown ? 'ri-eye-off-line' : 'ri-eye-line'} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </>
              )}
              {/* Login Buttons */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  gap: 2
                }}
              >
                <CustomButton type='submit' loading={loading} color='primary'>
                  Log In
                </CustomButton>
                {open && (
                  <CustomButton type='button' onClick={handleCloseUnit} loading={loading} color='secondary'>
                    Log Out
                  </CustomButton>
                )}
              </Box>
              {/* <Divider>Tidak Bisa Login?</Divider>
              <CustomButton
                loading={false}
                fullWidth={true}
                type='button'
                color='info'
                onClick={() => setOpenFingerprintDialog(true)}
                size='small'
              >
                Get Device ID
              </CustomButton> */}
            </form>
          </div>
        </div>
      </div>

      <Dialog
        open={openFingerprintDialog}
        onClose={() => setOpenFingerprintDialog(false)}
        maxWidth='xs'
        fullWidth
        transitionDuration={0}
      >
        <DialogContent className='overflow-visible pbs-0 sm:pbe-2 sm:pli-5'>
          <div className='flex justify-between items-center mb-5 mt-5'>
            <Typography variant='h5'>Fingerprint ID</Typography>
            <IconButton onClick={() => setOpenFingerprintDialog(false)} color='primary' size='small' tabIndex={-1}>
              <i className='ri-close-line' />
            </IconButton>
          </div>
          <Box sx={{ py: 2 }}>
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2, textAlign: 'center' }}>
              Silakan copy code ini dan kasihkan ke pihak IT
            </Typography>
            <Typography
              variant='body1'
              sx={{
                wordBreak: 'break-all',
                fontFamily: 'monospace',
                bgcolor: 'grey.100',
                p: 2,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'grey.300',
                mb: 2
              }}
            >
              {fingerprintId || 'Loading...'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CustomButton
                loading={false}
                type='button'
                color='primary'
                onClick={() => {
                  if (fingerprintId) {
                    navigator.clipboard.writeText(fingerprintId)
                    showToastAlert('success', 'Fingerprint ID berhasil disalin!')
                    setOpenFingerprintDialog(false)
                  }
                }}
                size='small'
              >
                Copy
              </CustomButton>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Login
